import { create } from '@bufbuild/protobuf'
import { type ConnectError } from '@connectrpc/connect'
import { useQuery } from '@connectrpc/connect-query'
import { listDemandProcurementMasters } from '@ebalance/proto/bffuser/v1/occto_master_service-OcctoMasterService_connectquery'
import {
  ListDemandProcurementMastersRequestSchema,
  type ListDemandProcurementMastersResponse,
} from '@ebalance/proto/bffuser/v1/occto_master_service_pb'
import type { UseQueryResult } from '@tanstack/react-query'

/**
 * 需要調達計画マスタ 一覧取得 hook。
 */
export function useListDemandProcurementMasters(): UseQueryResult<
  ListDemandProcurementMastersResponse,
  ConnectError
> {
  return useQuery(
    listDemandProcurementMasters,
    create(ListDemandProcurementMastersRequestSchema),
  )
}
